/**
 * Cambio della propria password.
 *
 * Il server lo permetteva già, ma nessuna schermata lo usava: per cambiare
 * password bisognava chiederlo all'amministratore. Si chiede la password
 * attuale — è ciò che impedisce a chi trova un computer lasciato aperto di
 * cambiarla al posto del titolare — e la nuova due volte, per non
 * chiudersi fuori con un errore di battitura.
 */
import { useState } from 'react';
import Modal from './Modal';
import { authApi } from '../api';

export default function CambiaPassword({ onClose }) {
  const [vecchia, setVecchia] = useState('');
  const [nuova, setNuova] = useState('');
  const [ripeti, setRipeti] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [fatto, setFatto] = useState(false);
  const [errore, setErrore] = useState('');

  const problema =
    nuova && nuova.length < 8 ? 'Almeno 8 caratteri.'
    : ripeti && nuova !== ripeti ? 'Le due password non coincidono.'
    : nuova && nuova === vecchia ? 'Deve essere diversa da quella attuale.'
    : '';
  const pronta = vecchia && nuova && ripeti && !problema;

  const salva = async (e) => {
    e.preventDefault();
    if (!pronta) return;
    setSalvando(true); setErrore('');
    try {
      await authApi.changePassword({ vecchia, nuova });
      setFatto(true);
    } catch (err) { setErrore(String(err)); } finally { setSalvando(false); }
  };

  return (
    <Modal title="Cambia password" onClose={onClose} size="sm">
      {fatto ? (
        <div className="space-y-4">
          <p className="text-sm text-green-700">
            ✓ Password cambiata. Dal prossimo accesso usa quella nuova.
          </p>
          <div className="flex justify-end">
            <button className="btn-primary" onClick={onClose}>Chiudi</button>
          </div>
        </div>
      ) : (
        <form onSubmit={salva} className="space-y-3">
          <div>
            <label className="label">Password attuale</label>
            <input className="input" type="password" autoComplete="current-password" autoFocus
                   value={vecchia} onChange={e => setVecchia(e.target.value)} />
          </div>
          <div>
            <label className="label">Nuova password</label>
            <input className="input" type="password" autoComplete="new-password"
                   value={nuova} onChange={e => setNuova(e.target.value)} />
          </div>
          <div>
            <label className="label">Ripeti la nuova password</label>
            <input className="input" type="password" autoComplete="new-password"
                   value={ripeti} onChange={e => setRipeti(e.target.value)} />
          </div>
          {(problema || errore) && (
            <p className="text-xs text-red-600">{errore || problema}</p>
          )}
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" className="btn-secondary" onClick={onClose}>Annulla</button>
            <button type="submit" className="btn-primary" disabled={!pronta || salvando}>
              {salvando ? 'Salvo…' : 'Cambia password'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
}
